import styled from '@emotion/styled';
import { Button } from '@ui-components/neo.tax';

export const ButtonStyled = styled(Button)({
  margin: 0,
  width: 'fit-content',
  alignSelf: 'flex-end',
});
